import { useFetchData } from "@/hooks/useFetchData";
import { useMutateData } from "@/hooks/useMutateData";
import { notificationService } from "@/views/notifications/api/notificationService";

export const useGetAllNotifications = (params?: any, options?: any,) => {
    return useFetchData({
        queryFn: () => notificationService.getAllNotifications(params),
        queryKey: ["notifications", params],
        ...options,
    });
};

export const useGetById = (id: string, options?: any) => {
    return useFetchData({
        queryFn: () => notificationService.getById(id),
        queryKey: ["notification", id],
        enableCondition: !!id,
        ...options,
    });
};

export const useGetCountUnreadNotifications = (options?: any) => {
    return useFetchData({
        queryFn: () => notificationService.getCountUnreadNotifications(),
        queryKey: ["count-unread-notifications"],
        ...options,
    });
};



export const useCreateUserNotification = (options?: any) => {
    return useMutateData({
        mutationFn: (formData: FormData) => notificationService.createUserNotification(formData),
        ...options,
    });
};

export const useCreateCustomNotification = (options?: any) => {
    return useMutateData({
        mutationFn: (formData: FormData) => notificationService.createCustomNotification(formData),
        ...options,
    });
};